import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import "./App.css";

import DesktopHome from "./pages/DesktopHome";
import Layout from "./components/Layout";
import About from "./pages/About";
import Photography from "./pages/Photography";
import Gallery from "./pages/Gallery";
import Films from "./pages/Films";
import Blogs from "./pages/Blogs";
import BlogPost from "./pages/BlogPost";
import GetInTouch from "./pages/GetInTouch";
import CoupleGallery from "./pages/CoupleGallery";
import Admin from "./pages/Admin";
import ViewAllClients from "./pages/ViewAllClients";
import ClientGallery from "./pages/ClientGallery";

// ✅ NEW TESTIMONIAL PAGES
import Reviews from "./pages/Reviews";
import AddReview from "./pages/AddReview";

import ScrollToTop from "./components/ScrollToTop";
import useVisitorAlert from "./useVisitorAlert";
function App() {
  
  useVisitorAlert();
  return (
    <Router>
      <ScrollToTop />

      <div className="App noise-bg font-elena-ap">
        <Routes>
          {/* HOME */}
          <Route path="/" element={<DesktopHome />} />

          {/* LAYOUT WRAPPED ROUTES */}
          <Route element={<Layout />}>
            <Route path="/admin" element={<Admin />} />
            <Route path="/about" element={<About />} />
            <Route path="/photography" element={<Photography />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/films" element={<Films />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blogs/:slug" element={<BlogPost />} />
            <Route path="/get-in-touch" element={<GetInTouch />} />

            {/* COUPLES */}
            <Route path="/couples/:slug" element={<CoupleGallery />} />

            {/* CLIENTS */}
            <Route path="/clients" element={<ViewAllClients />} />
            <Route path="/clients/:clientId" element={<ClientGallery />} />

            {/* ⭐ TESTIMONIALS */}
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/add-review" element={<AddReview />} />
          </Route>

          {/* FALLBACK */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
